import {EventModelState} from "src/state/slice/EventModelSlice";
import React from "react";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {SolutionDetailAttribute} from "src/entity/entities";
import * as solutionConfig from "src/config/solutionConfigs.json";
import {Col, Row} from "@amzn/stencil-react-components/layout";
import {Link} from "@amzn/stencil-react-components/link";
import "src/components/authoringComponents/styles/LinkComponent.scss";

interface ILinkInput {
    attributeName: string;
    attributeValue: string;
}

/**
 * This component displays a link (only display, not add / create)
 */
export const LinkComponent = ({attributeName, attributeValue}: ILinkInput) => {
    return <Link
        href={attributeValue}
        target="_blank"
    >
        {attributeValue}
    </Link>
}
